import { AnyPage } from '@src/app/shared/typings/enum/pages.js'

/**
 * An abstraction of a route built from a series of Pages
 *
 * It's a container for a toString method that returns the route as a string, slash-separated
 */
export class PagePath {
  public pages: AnyPage[]
  constructor(...pages: AnyPage[]) {
    this.pages = pages
  }

  public toString(): string {
    return this.pages.join('/')
  }
}
